module.exports = {
  menu: {
    home: 'होम',
    game: 'खेल',
    connect_login: 'वॉलेट कनेक्ट/लॉगिन',
    new_game: 'खेल में प्रवेश करें',
    invite_friends: 'मित्रों को आमंत्रित करें',
    cms_login: 'सीएमएस लॉगिन',
    register: 'रजिस्टर करें',
    login: 'लॉगिन',
    logout: 'लॉगआउट',
    login_to_play_game: 'खेल खेलने के लिए लॉगिन करें',
    select_login_method: 'लॉगिन विधि चुनें',
    select_register_method: 'रजिस्टर विधि चुनें',
    email: 'ईमेल',
    meta_mask: 'मेटामास्क',
    player_login: 'खिलाड़ी लॉगिन',
    history: 'इतिहास',
    transaction_history: 'लेनदेन इतिहास',
    ranking: 'रैंकिंग',
    purchase: 'रीचार्ज',
    search_game_placeholder: 'खेल खोजें..',
    new_games: 'नए खेल',
    frequent: 'अक्सर खेले जाने वाले खेल',
    faq: 'अक्सर पूछे जाने वाले प्रश्न',
    terms_and_conditions: 'Win4Poker के नियम और शर्तें',
    tnc: 'नियम और शर्तें',
    about_us: 'हमारे बारे में',
    contact_us: 'संपर्क करें',
    settings: 'सेटिंग्स',
    lucky_draw: 'लकी ड्रॉ',
    tournament: 'टूर्नामेंट',
    announcement: 'घोषणा',
    no_news: 'कोई समाचार नहीं',
    online: 'ऑनलाइन',
    deposit: 'जमा',
    terms_1_title: 'भाग लेने की योग्यता',
    terms_1_content:
      'सभी खिलाड़ियों को 18 वर्ष या उससे अधिक होना चाहिए, और वे उन क्षेत्रों में पंजीकरण और खेल कर सकते हैं जहाँ कानून अनुमति देता है।',
    terms_2_title: 'खाता पंजीकरण',
    terms_2_content: 'खिलाड़ी को आधिकारिक वेबसाइट के माध्यम से खाता पंजीकृत करना होगा।',
    terms_3_title: 'खेल के नियम',
    terms_3_content:
      'सभी खेल मानक पोकर नियमों का पालन करना चाहिए, किसी भी धोखाधड़ी के कृत्य से खाता निलंबित या बंद किया जा सकता है।',
    terms_4_title: 'जमा और निकासी',
    terms_4_content:
      'खिलाड़ियों को इस प्लेटफ़ॉर्म के भुगतान तरीकों का उपयोग करके जमा करना होगा, निकासी प्लेटफ़ॉर्म की प्रक्रिया समय के अनुसार की जाएगी।',
    terms_5_title: 'बोनस वितरण',
    terms_5_content:
      'बोनस खेल के परिणामों के आधार पर वितरित किया जाएगा, विशेष नियम खेल शुरू होने से पहले बताए जाएंगे।',
    terms_6_title: 'दायित्व सीमा',
    terms_6_content:
      'प्लेटफ़ॉर्म किसी भी सेवा या उत्पाद के उपयोग से उत्पन्न हानि या चोट के लिए जिम्मेदार नहीं है।',
    terms_7_title: 'गोपनीयता संरक्षण',
    terms_7_content:
      'खिलाड़ियों की व्यक्तिगत जानकारी गोपनीय रखी जाएगी, केवल खाता प्रबंधन और खेल उद्देश्यों के लिए उपयोग की जाएगी।',
    terms_8_title: 'नियम संशोधन',
    terms_8_content:
      'प्लेटफ़ॉर्म नियमों और शर्तों में किसी भी समय संशोधन करने का अधिकार रखता है, संशोधन ईमेल या वेबसाइट पर घोषणा के माध्यम से खिलाड़ियों को सूचित किया जाएगा।',
  },
  common: {
    theme: 'बेसिक आइटम बैकएंड',
    delete_record_confirm_msg: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    yes: 'हाँ',
    no: 'नहीं',
    true: 'सच',
    false: 'झूठ',
    success: 'सफलता',
    loading: 'लोड हो रहा है',
    or: 'या',
    delete: 'हटाएं',
    login: 'लॉगिन',
    submit: 'जमा करें',
    apply: 'लागू करें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    back_to_lobby: 'लॉबी पर वापस जाएं',
    email: 'ईमेल',
    id_document: 'पहचान दस्तावेज़',
    all_in_game: 'ऑल-इन फोल्ड टेक्सास होल्डेम',
    all_in_game_omaha: 'ऑल-इन फोल्ड ओमाहा',
    regular: 'टेक्सास होल्डेम',
    regular_description: 'टेक्सास होल्डेम असीमित बेटिंग के साथ खेला जाता है',
    short: 'शॉर्ट डेक',
    short_description: 'शॉर्ट डेक टेक्सास होल्डेम 36 कार्ड के साथ खेला जाता है',
    omaha: 'ओमाहा',
    omaha_description: 'खिलाड़ियों को अपने हाथ बनाने के लिए दो होल कार्ड का उपयोग करना चाहिए',
    regular_allin: 'ऑल-इन फोल्ड टेक्सास होल्डेम',
    omaha_allin: 'ऑल-इन फोल्ड ओमाहा',
    tournament: 'टूर्नामेंट',
    start: 'टेबल खोलें',
    game_demo_area: 'गेम अनुभव क्षेत्र',
    total_win_prize: 'कुल जीत इनाम',
    waiting_list_order: 'वेटिंग लिस्ट क्रम',
    join_more_than_4_room_error: 'एक से अधिक 4 कमरों में शामिल नहीं हो सकते',
    system_message: 'सिस्टम संदेश',
    error: 'त्रुटि',
    register: 'रजिस्टर करें',
    meta_mask: 'मेटामास्क',
    wallet_connect: 'वॉलेट कनेक्ट',
    password: 'पासवर्ड',
    next_step: 'अगला कदम',
    next: 'अगला',
    verify: 'सत्यापित करें',
    copy_success: 'सफलतापूर्वक कॉपी किया गया',
    enabled: 'सक्षम',
    enable: 'सक्षम करें',
    disable: 'अक्षम करें',
    done: 'पूरा',
    feature_in_progress: 'सिफारिश की जा रही विशेषता विकासाधीन है, कृपया बाद में पुनः देखें।',
    no_data: 'कोई डेटा नहीं',
    date: 'तारीख',
    retry: 'पुनः प्रयास करें',
    location_restricted_title: 'स्थान प्रतिबंधित',
    location_restricted_content:
      'आपका वर्तमान स्थान प्रतिबंधित है। कुछ सुविधाएँ या सेवाएँ उपलब्ध नहीं हो सकती हैं। आपकी समझदारी के लिए धन्यवाद।',
    dont_show_again: 'फिर से न दिखाएं',
    edit: 'संपादित करें',
    i_am_not_located_in_the_restricted_country: 'मैं सीमित देश में नहीं हूँ',
  },
  auth: {
    nickname: 'उपनाम',
    connect_to_win_4_poker: 'WIN 4 POKER से कनेक्ट करें',
    wallet_connect_need_to_connect_ur_wallet:
      'ऐप्लिकेशन को आपके वॉलेट से कनेक्ट करने की आवश्यकता है',
    wallet_connect_sign_this_message:
      'कृपया इस संदेश पर हस्ताक्षर करने के लिए वापस वॉलेट पर जाएं ताकि यह साबित हो सके कि आपके पास यह वॉलेट है और जारी रखने के लिए। रद्द करने पर कनेक्शन टूट जाएगा।',
    sign_request_in_wallet: 'वॉलेट में अनुरोध पर हस्ताक्षर करें',
    sign_message_success: 'संदेश पर हस्ताक्षर सफल',
    cancel: 'रद्द करें',
    sign: 'हस्ताक्षर करें',
    confirm_password: 'पासवर्ड की पुष्टि करें',
    referral_code: 'रेफरल कोड',
    i_have_read_the_agreement: 'मैंने समझौता पढ़ लिया है',
    should_accept_agreement: 'कृपया समझौते को स्वीकार करें',
    alphabet_validation: 'कम से कम एक अक्षर वर्ण शामिल होना चाहिए',
    numeric_validation: 'कम से कम एक अंक शामिल होना चाहिए',
    length_validation: 'कम से कम 8 वर्ण, लेकिन 20 वर्ण से अधिक नहीं',
    placeholder: {
      enter_user_name: 'उपयोगकर्ता नाम दर्ज करें',
      enter_email: 'ईमेल दर्ज करें',
      enter_password: 'पासवर्ड दर्ज करें',
      confirm_password: 'पासवर्ड की पुष्टि करें',
      enter_referral_code: 'रेफरल कोड दर्ज करें',
    },
    error_messages: {
      nickname: 'कृपया अपना उपनाम दर्ज करें',
      email_invalid: 'यह एक अमान्य ईमेल है',
      email_required: 'कृपया अपना ईमेल दर्ज करें',
      password_required: 'कृपया अपना पासवर्ड दर्ज करें',
      password_confirm_required: 'कृपया अपना पासवर्ड पुष्टि करें',
      password_confirm_not_matched: 'आपके द्वारा दर्ज किए गए दोनों पासवर्ड मेल नहीं खाते!',
      incorrect_email_or_password: 'ईमेल या पासवर्ड गलत है',
      error_occurred: 'त्रुटि हुई, कृपया बाद में पुनः प्रयास करें',
    },

    // login-email page
    forget_password: 'पासवर्ड भूल गए?',

    // forgot-password page
    forgot_password_title: 'पासवर्ड भूल गए',
    please_enter_email_registered: 'कृपया अपना पंजीकृत ईमेल दर्ज करें',

    // email-verification page
    email_verification: 'ईमेल सत्यापन',
    email_has_been_sent_to: '{{value}} पर ईमेल भेजा गया है',
    email_resend_countdown_message:
      'ईमेल नहीं मिला? आप <0>काउंटडाउन</0> सेकंड के बाद पुनः ईमेल भेजने का अनुरोध कर सकते हैं',
    please_check_your_email: 'कृपया अपना ईमेल जांचें',
    waiting_to_verify_email: 'आपके ईमेल को सत्यापित किया जा रहा है',
    agree_terms_and_privacy:
      'यदि आप इस प्रक्रिया को जारी रखते हैं, तो इसका मतलब है कि आप हमारे <0>नियम</0> और <1>गोपनीयता नीति</1> से सहमत हैं।',
    terms: 'नियम',
    privacy_policy: 'गोपनीयता नीति',

    // metamask-complete-registration page
    complete_metamask_registration: 'मेटामास्क पंजीकरण पूरा करें',

    // reset-password page
    reset_password: 'पासवर्ड रीसेट करें',
    you_may_now_reset_password: 'आप अब अपने खाते के लिए पासवर्ड रीसेट कर सकते हैं।',

    register_an_account: 'अभी तक खाता नहीं है? <0>यहाँ रजिस्टर करें</0>!',
    resend_code_message: 'ईमेल प्राप्त नहीं हुआ? यहाँ क्लिक करें <0>पुनः भेजें</0>',

    // 2FA setup page
    two_fa_via_email_title: 'ईमेल के माध्यम से दो-कारक प्रमाणीकरण',
    otp_has_been_sent_to_email: 'एक बार प्रमाणीकरण कोड आपके पंजीकृत ईमेल पते पर भेज दिया गया है।',
    two_factor_authentication: 'दो-कारक प्रमाणीकरण',
    scan_this_qr_code_msg:
      'दो-कारक प्रमाणीकरण (2FA) सेटअप करने के लिए, कृपया इस क्यूआर कोड को Authy या Google Authenticator जैसे ऐप के साथ स्कैन करें।',
    choose_scan_qr_code_msg:
      'प्रमाणीकरण ऐप खोलें, नीचे दाएं कोने पर + आइकन पर क्लिक करें। क्यूआर कोड स्कैन करने का चयन करें।',
    choose_enter_setup_key_msg:
      'प्रमाणीकरण ऐप खोलें, नीचे दाएं कोने पर + आइकन पर क्लिक करें। सेटअप कुंजी दर्ज करने का चयन करें।',
    secret_key: 'गुप्त कुंजी',
    enter_code_in_authenticator_app: 'कृपया प्रमाणीकरण ऐप में दिखाए गए कोड को दर्ज करें।',
    two_fa_is_set: {
      title: '2FA सेट हो गया है',
      message: 'आपने 2FA सेट कर लिया है, निकासी सुविधा अब उपलब्ध है।',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function:
      'कुछ सुविधाओं को अनलॉक करने के लिए ईमेल सत्यापन पूरा करें',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'निकासी राशि को 100,000 USDT तक बढ़ाने के लिए पहचान सत्यापन पूरा करें',
    connect_wallet_to_spin: 'वॉलेट कनेक्ट करें',

    // enter code page
    link_email: 'ईमेल लिंक',
    unlink_email: 'ईमेल अनलिंक',
    expires_in: 'अवधि में <0>मिनट</0>.',
    resend_code: '<0>रिसेंड कोड</0>',
    enter_code: 'कोड दर्ज करें',
    unlink_email_confirm_msg: 'क्या आप वाकई ईमेल अनलिंक करना चाहते हैं?',
    link_success: 'ईमेल लिंक सफलतापूर्वक',
    unlink_success: 'ईमेल अनलिंक सफलतापूर्वक',
  },
  slider: {
    about: 'बारे में',
    support: 'समर्थन',
  },
  game_room: {
    confirm_leave_msg: 'क्या आप वाकई खेल छोड़ना चाहते हैं?',
    join_room_error_title: 'कक्ष में शामिल होने में त्रुटि',
    join_room_error_msg: 'कक्ष में शामिल होने में विफल, कृपया पुनः प्रयास करें',
    confirm_withdraw_extra_bet_msg: 'क्या आप अतिरिक्त चिप्स निकालने के लिए सुनिश्चित हैं',
    total_won_prize: 'कुल जीत इनाम: ${{val, number}}',
    your_balance: 'आपका शेष: ${{val, number}}',
    no_enough_balance: 'शेष न्यूनतम खरीद चिप्स से कम है: ${{val, number}}',
    cash_out: 'सिक्के निकालें और छोड़ें',
    continue_game: 'खेल जारी रखें',
    remark_placeholder: 'टिप्पणी',
    leave_seat: 'सीट छोड़ें',
    sit_in: 'सीट पर वापस आएं',
    buy_in: 'खरीदें',
    buy_in_min_amount: 'न्यूनतम',
    buy_in_max_amount: 'अधिकतम',
    seconds: 'सेकंड',
    close_drawer: 'बंद करें',
    leave_game: 'खेल छोड़ें',
    back_to_lobby: 'लॉबी में वापस जाएं',
    leave_table: 'टेबल छोड़ें',
    you_have_copied_room_code: 'आपने कक्ष आमंत्रण कोड कॉपी कर लिया है: {{value}}',
    invitation_message:
      'तुरंत {{playerName}} द्वारा बनाए गए गेम रूम में प्रवेश करें! कक्ष आमंत्रण कोड {{roomNumber}}, खेल शुरू करें!',
    link_copied: 'आपने लिंक सफलतापूर्वक कॉपी कर लिया है',
    please_wait_until_connected: 'कृपया जुड़ने का इंतजार करें',
    rejoin_room: 'कक्ष में वापस जाएं',
    theme_setting: 'थीम सेटिंग',
    room_code_share: 'कक्ष आमंत्रण कोड कॉपी करें',
    room_link_copy: 'लिंक साझा करें',
    table_setting: 'टेबल सेटिंग',
    emoji_menu: 'इमोजी मेनू',
    history_drawer: 'कक्ष इतिहास',
    deposit: 'जमा',
    withdraw_extra_bet: 'अतिरिक्त चिप्स निकालें',
    add_extra_bet: 'अतिरिक्त चिप्स जोड़ें',
    unit_convert: 'इकाई बदलें',
    silent_mode_on: 'मौन मोड: चालू',
    silent_mode_off: 'मौन मोड: बंद',
    raise_to: 'तक बढ़ाएं',
    winner: 'विजेता',
    player_status: {
      disconnected: 'ऑफ़लाइन',
      sat_out: 'सीट छोड़ दी',
    },
    win_percentage: 'जीत प्रतिशत',
    all_in: 'ऑल-इन',
    ping_popup_msg: 'नेटवर्क सिग्नल असामान्य है, पुनः कनेक्ट करने का प्रयास कर रहा है',
    ping_popup_title: 'नेटवर्क सिग्नल असामान्य',
    ping_popup_content:
      'पुनः कनेक्ट करने का प्रयास किया जा रहा है, आप पेज को रिफ्रेश करने का प्रयास कर सकते हैं',
    disconnected_modal_title: 'नेटवर्क सिग्नल असामान्य',
    afk_timer_text:
      'क्योंकि आपने लंबे समय तक प्रतिक्रिया नहीं दी, आपको सीट से हटा दिया गया है। यदि आप निर्धारित समय के भीतर टेबल पर वापस नहीं आते हैं, तो आप कक्ष से हटा दिए जाएंगे',
    regular: 'टेक्सास होल्डेम',
    short: 'शॉर्ट डेक',
    omaha: 'ओमाहा',
    omaha_all_in: 'ऑल-इन फोल्ड ओमाहा',
    buyin_option: 'खरीद विकल्प',
    buy_in_amount: 'खरीद राशि',
    reminder: 'अनुस्मारक',
    not_enough_balance_to_buy_in: 'खरीदने के लिए पर्याप्त शेष नहीं है।',
    sitting_out: 'सीट छोड़ दी',
    not_leaving_temporarily: 'अस्थायी रूप से नहीं छोड़ना',
    back_to_home: 'मुख्य पृष्ठ पर वापस जाएं',
    are_you_sure_leave_table: 'आप उच्चतम बेटिंग खिलाड़ी हैं, क्या आप वाकई बाहर निकलना चाहते हैं?',
    leave_table_with_highest_bet_error:
      'आप उच्चतम बेटिंग खिलाड़ी हैं, आप टेबल नहीं छोड़ सकते। कृपया बाद में पुन: प्रयास करें।',
    loading_room_data: 'कक्ष डेटा लोड हो रहा है...',
    sit_out_tournament_warning: {
      title: 'टूर्नामेंट से बाहर बैठने की चेतावनी',
      msg: 'आप वर्तमान में एक टूर्नामेंट में हैं। यदि आप बाहर बैठते हैं, तो आपको अभी भी ब्लाइंड्स के लिए भुगतान करना होगा।',
    },
  },
  player_action: {
    bet: 'बेट',
    call: 'कॉल',
    check: 'चेक',
    raise: 'बढ़ाएं',
    fold: 'फोल्ड',
    bb: 'बिग ब्लाइंड',
    sb: 'स्मॉल ब्लाइंड',
    ante: 'एंटे',
    all_in: 'ऑल-इन',
    insurance_cancel: 'बीमा रद्द करें',
    insurance_buy: 'बीमा खरीदें',
  },
  game_demo: {
    experience_progress: 'अनुभव कोड पूरा प्रगति',
    game_experience_zone: 'गेम अनुभव क्षेत्र',
    action_to_redemption: '30 वैध खेलों को पूरा करके नकद कोड में बदलें',
    remaining_game_experience_code: 'अभी भी {{val, number}} बाकी हैं',
    cash_code_exchange: 'नकद कोड विनिमय',
    successfully_finish_30_games: 'सफलतापूर्वक पूरा किया गया',
    congrats: 'बधाई हो!',
    successful_exchange_cash_code: '{{amount}} नकद कोड सफलतापूर्वक बदला गया',
    how_to_redeem: 'अनुभव कोड कैसे नकद कोड में बदला जाए',
    successful_condition_of_redemption: 'शर्तें: 30 वैध खेलों को पूरा करना',
    two_to_three_players: '2-3 खिलाड़ी का खेल',
    explanation_of_valid_game:
      '10BB तक पहुँचें और एंडगेम में खुद को दिखाएं, तभी एक वैध खेल माना जाएगा',
    more_than_four_players: '4 या उससे अधिक खिलाड़ियों का खेल',
  },
  userProfile: {
    profile_settings: 'प्रोफ़ाइल सेटिंग्स',
    initial_setting_title: 'Win4.Poker में आपका स्वागत है',
    initial_setting_description:
      'कृपया नीचे प्रारंभिक सेटिंग को पूरा करें और हमारे खेलों का आनंद लें',
    display_name: 'खिलाड़ी नाम',
    profile_picture: 'खिलाड़ी प्रोफ़ाइल चित्र',
    edit: 'संपादित करें',
    balance: 'बैलेंस',
    coin: 'USD',
    demo_coin: 'नकद अनुभव कोड',
    diamond: 'हीरा',
    game_record: 'खेल रिकॉर्ड',
    ranking_list: 'रैंकिंग सूची',
    game_review: 'खेल पुनरावलोकन',
    shortcut_setting: 'शॉर्टकट सेटिंग',
    user_name: 'उपयोगकर्ता नाम:',
    recommend_code: 'रेफरल कोड',
    upload_image_msg: 'छवि को यहाँ खींचें, या',
    upload_image_browser_msg: 'ब्राउज़र',
    upload_image_file_size: '(फाइल आकार अधिकतम: 68px*93px)',
    username_length_message: 'उपयोगकर्ता नाम की लंबाई 3-24 के बीच होनी चाहिए',
    chinese_username_length_message:
      'चाइनीज़ वर्णों वाला उपयोगकर्ता नाम 1-5 के बीच लंबा होना चाहिए',
    username_char_message:
      "उपयोगकर्ता नाम में केवल अक्षर, संख्या, चीनी वर्ण और '_'/'-'/'.' शामिल हो सकते हैं",
    personal_information: 'व्यक्तिगत जानकारी',
    user_icon: 'उपयोगकर्ता आइकन:',
    save: 'सहेजें',
    my_profile: 'मेरा प्रोफ़ाइल',
    my_balance: 'मेरा बैलेंस',
    deposit_withdraw: 'जमा/निकासी',
    my_record: 'मेरा रिकॉर्ड',
    flow_record: 'फ्लो रिकॉर्ड',
    total_earnings: 'कुल आय',
    country: 'देश',
    disclaimer: 'अंगार',
  },
  maintenance: {
    title: 'साइट मेंटेनेंस पर है',
    content:
      'हम उपयोगकर्ता अनुभव में सुधार करने के लिए काम कर रहे हैं। हम जल्द ही वापस आ रहे हैं। आपके धैर्य के लिए धन्यवाद।',
  },
  useSetting: {
    card_front: 'कार्ड फ्रंट',
    card_back: 'कार्ड बैक',
    table: 'टेबल',
    add_token_msg: 'क्या आपको और टोकन जोड़ने की आवश्यकता है?',
  },
  lucky_draw: {
    award_history: 'पुरस्कार रिकॉर्ड',
    lucky_draw_rules: 'नियम',
    remaining_lucky_draw_amount: 'शेष स्पिन: {{value}}',
    remaining_lucky_draw_amount_loading_label: 'शेष स्पिन: ',
    spin_wheel_10_times: 'पहिया दस बार घुमाएं',
    spin_wheel: 'पहिया घुमाएं',
    participation_rate: 'खेल भागीदारी दर: {{count}}',
    coin_loss: 'सिक्कों की हानि दर',
    congrats: 'बधाई हो!',
    you_have_won: 'आपने ${{prize}} जीता है',
    collect_prize: 'पुरस्कार प्राप्त करें',
    select_category: 'ड्रा श्रेणी का चयन करें: ',
    special_combination: 'विशेष संयोजन: ',
    no_history: 'कोई ड्रा इतिहास नहीं मिला',
    no_data: 'कोई डेटा उपलब्ध नहीं है',
    spin: 'स्पिन करें',
    fortune_wheel: 'फॉर्च्यून व्हील',
    christmas_fortune_wheel: 'क्रिसमस फॉर्च्यून व्हील',
    new_year_fortune_wheel: 'नया साल फॉर्च्यून व्हील',
    cny_fortune_wheel: 'चाइनिज न्यू ईयर फॉर्च्यून व्हील',
    email_login: 'ईमेल लॉगिन',
    thank_you: 'धन्यवाद',
    miss_msg_1:
      'हमारे कार्यक्रम में भाग लेने के लिए धन्यवाद, आपके पास कोई शेष स्पिन नहीं है, आप हमारे खेल में शामिल होकर अधिक पैसा कमा सकते हैं। आनंद लें और शुभकामनाएँ।',
    play_now: 'अभी खेलें',
    win_msg:
      'आपने जीता <br/> <large>{{prize}}</large> <br /> और आपके बैलेंस में सुरक्षित कर दिया गया है।',
    draw_again_msg:
      'आपके पास <yellow>{{numOfDraws}}</yellow> ड्रॉ बचे हैं। <clickable>फिर से ड्रॉ करने के लिए क्लिक करें।</clickable>',
    diamond: '{{value}} हीरा',
    redeem_now: 'अभी भुनाएं',

    deposit_more_than_10: '$10 से अधिक जमा करें',
    get_1_free_spin: '1 मुफ्त स्पिन प्राप्त करें',
    win_10_times: '10 बार जीतें',
  },
  combination: {
    hi_card: 'उच्च कार्ड',
    pair: 'एक जोड़ी',
    one_pair: 'एक जोड़ी',
    two_pairs: 'दो जोड़ी',
    set: 'तीन समान',
    three_of_a_kind: 'तीन समान',
    straight: 'सीधी',
    flush: 'फ्लश',
    fullHouse: 'फुल हाउस',
    full_house: 'फुल हाउस',
    quad: 'चार समान',
    straight_flush: 'सीधी फ्लश',
    royal_flush: 'रॉयल फ्लश',
  },
  room_type: {
    public: 'सार्वजनिक कमरा',
    private: 'निजी कमरा',
  },
  forgot_password: {
    reset_password: 'पासवर्ड रीसेट करें',
    password: 'पासवर्ड',
    confirm_password: 'पासवर्ड की पुष्टि करें',
    phone: 'फोन',
  },
  error: {
    please_confirm: 'कृपया पुष्टि करें',
    password_inconsistent: 'पासवर्ड असंगत है',
    file_size_limit_error: 'अपलोड की गई फ़ाइल का आकार {{size}} तक सीमित है',
    please_input: 'कृपया {{field}} दर्ज करें',
  },
  translation: {
    success: 'सफलता',
  },
  game_list: {
    table: 'टेबल',
    random_join_table: 'रैंडम टेबल में शामिल हों',
    random_join: 'रैंडम शामिल हों',
    join: 'शामिल हों',
    no_room_available: 'कोई कमरा उपलब्ध नहीं है, कृपया बाद में वापस आएं।',
    all_game_loaded: 'सभी खेल लोड हो गए हैं',
    join_waiting_list: 'वेटिंग लिस्ट में शामिल हों',
    join_table: 'टेबल में शामिल हों',
    join_observer: 'निरीक्षक बनें',
    game_code: 'खेल कोड',
    game_type: 'खेल प्रकार',
    game_limit: 'सर्वोच्च संख्या',
    game_players: 'खिलाड़ी',
    game_unit_test: 'यूनिट टेस्ट',
    game_basicBet: 'बेसिक बेट',
    game_SB: 'एसबी',
    game_smallBlind: 'स्मॉल ब्लाइंड',
    regular: 'टेक्सास होल्डेम',
    all_in: 'ऑल-इन फोल्ड टेक्सास होल्डेम',
    short: 'शॉर्ट डेक',
    omaha: 'ओमाहा',
    omaha_all_in: 'ऑल-इन फोल्ड ओमाहा',
    buy_in: 'खरीदें',
    tables: 'टेबल',
    notice: 'सूचना',
    time_difference_reminder:
      'आपके सिस्टम समय और इंटरनेट समय के बीच असामान्य अंतर है, जो खिलाड़ी काउंटडाउन फ़ंक्शन को प्रभावित कर सकता है। सर्वोत्तम प्रदर्शन और सटीकता सुनिश्चित करने के लिए, कृपया जल्द से जल्द सिस्टम समय सिंक करें।',
    player_category: 'खिलाड़ी श्रेणी',
    blind_category: 'ब्लाइंड श्रेणी',
    table_category: 'टेबल श्रेणी',
    chips: 'चिप्स',
    player: 'खिलाड़ी',
    waiting: 'प्रतीक्षा',
    avg_pot: 'औसत पॉट',
    flop_rate: 'फ्लॉप दर',
    hands_per_hour: 'प्रति घंटा हाथ',
    no_of_hands_played: 'कुल हाथ खेले गए',
    win: 'जीत',
    invested: 'निवेश किया',
    pot: 'पॉट',
    usd_balance_updated: 'यूएसडी बैलेंस ${{balance}} तक अपडेट किया गया',
    new_room: 'नया कमरा',
    game: 'कैश गेम',
    tournament: 'टूर्नामेंट',
  },
  game_review: {
    my_bets: 'मेरे दांव',
    date_range: 'तारीख सीमा',
    select_date_range: 'तारीख सीमा चुनें',
    show_all_dates: 'सभी तारीखें दिखाएं',
    show_selected_dates: 'चयनित तारीखें दिखाएं',
    no_game_record: 'कोई खेल रिकॉर्ड नहीं',
    win_row_message: 'जीत!!',
    lose_row_message: 'खर्च',
    ante: 'एंटे',
    win: 'जीत',
    lose: 'हार',
    main_pot: 'मुख्य पॉट',
    side_pot: 'साइड पॉट {{number}}',
  },
  leader_board: {
    rank: 'रैंक',
    name: 'नाम',
    win_game: 'कुल जीत गेम्स',
    score: 'स्कोर',
  },
  home: {
    dont_miss_promotion_msg: 'इन्हें मिस न करें',
    all_promotions: 'सभी प्रचार',
    my_game: 'मेरा खेल',
    all_games: 'सभी खेल',
    claim_first_time_reward_button: 'जानें',
    first_time_login: 'पहली बार खेल में लॉगिन,',
    first_time_reward_msg: 'आपको {{val}} अनुभव सिक्के मिलेंगे',
    open_table: 'टेबल खोलें',
    open_new_room: 'नया कमरा खोलें',
    enter_room_number: 'कमरा कोड दर्ज करें',
    start: 'टेबल खोलें',
    enter_code: 'कोड दर्ज करें',
    confirm: 'पुष्टि करें',
    game_selection: 'खेल चयन',
    start_game: 'टेबल खोलें/कमरे में शामिल हों',
    game_record: 'खेल रिकॉर्ड',
    join_private_room: 'निजी कमरा जोड़ें',
    roomCode: 'कमरा कोड',
    please_enter_a_valid_room_code: 'कृपया मान्य कोड दर्ज करें',
    notice: 'सूचना',
    time_difference_reminder:
      'आपके सिस्टम समय और इंटरनेट समय के बीच असामान्य अंतर है, जो खिलाड़ी काउंटडाउन फ़ंक्शन को प्रभावित कर सकता है, कृपया जल्द से जल्द सिस्टम समय सिंक करें। यदि आपने सिंक कर लिया है, तो पेज को रिफ्रेश करें।',
    register_success: 'रजिस्ट्रेशन सफल',
    referral_code: 'रेफरल कोड',
    referral_code_placeholder: 'रेफरल कोड दर्ज करें',
    display_name: 'प्रदर्शित नाम',
    display_name_placeholder: 'प्रदर्शित नाम दर्ज करें',
    user: 'खिलाड़ी',
    bet_amount: 'बेट राशि',
    date: 'तारीख',
    multiplier: 'गुणक',
    payout: 'इनाम',
    free_game: 'मुफ्त खेल',
    play_without_money: 'पैसे के बिना खेलें',
    private_game: 'निजी कमरा',
    play_with_friends: 'मित्रों के साथ खेलें',
    regular_content: 'सामान्य टेक्सास होल्डेम असीमित बेटिंग के साथ खेला जाता है',
    all_in_content: 'ऑल-इन या फोल्ड टेक्सास होल्डेम असीमित बेटिंग के साथ खेला जाता है',
    short_content: 'शॉर्ट डेक टेक्सास होल्डेम असीमित बेटिंग के साथ खेला जाता है',
    omaha_content: 'पॉट लिमिट ओमाहा असीमित बेटिंग के साथ खेला जाता है',
    omaha_all_in_content: 'ऑल-इन या फोल्ड ओमाहा असीमित बेटिंग के साथ खेला जाता है',
    player_statistics: 'खिलाड़ी वर्तमान',
    lucky_draw_reminder: {
      title: 'याद दिलाना',
      message: 'आपके पास {{value}} लकी-ड्रॉ स्पिन बचे हैं',
      go_to_lucky_draw: 'लकी ड्रॉ पर जाएं',
      spin_now: 'अभी स्पिन करें',
    },
  },
  disclaimer: {
    title: 'अस्वीकरण',
    message:
      'यदि आप निम्नलिखित प्रतिबंधित क्षेत्रों में रहते हैं, तो आपको win4.poker पर खेल खेलने की अनुमति नहीं है',
    countryList:
      'अमेरिका, तुर्की, अरूबा, बोनल, कुरासो, फ्रांस, नीदरलैंड, स्वीडन, इजरायल, लिथुआनिया, स्लोवाकिया, बेल्जियम, स्विट्जरलैंड, स्बा, सेंट यूस्टस, सेंट मार्टिन, चीन, यूनाइटेड किंगडम.',
    checkbox_message:
      'मैं पुष्टि करता हूँ कि मेरी स्थिति में सट्टेबाजी मेरे क्षेत्र की प्राधिकरणों द्वारा निषिद्ध नहीं है, और मैं 18 वर्ष या उससे अधिक आयु का हूँ।',
    required_message: 'कृपया अस्वीकरण से सहमत हों',
  },
  login: {
    user_account: 'उपयोगकर्ता नाम',
    password: 'पासवर्ड',
    cash_web_login: 'नकद वेब उपयोगकर्ता लॉगिन',
    player_register: 'खिलाड़ी पंजीकरण',
    gateway_user_name: 'गेटवे उपयोगकर्ता नाम',
    cms_login: 'सीएमएस लॉगिन',
    deposit: 'जमा',
    deposit_amount: 'जमा राशि',
    deposit_message: 'जमा राशि भरने की आवश्यकता है',
    notice: 'सूचना',
    duplicate_login: 'एक ही IP लॉगिन का पता चला',
    redirecting: 'आपका पृष्ठ जल्द ही लोड हो जाएगा, आपके धैर्य के लिए धन्यवाद।',
    loading: 'संसाधन लोड हो रहे हैं, कृपया प्रतीक्षा करें...',
  },
  verification: {
    email_verification_code: 'ईमेल सत्यापन कोड',
    email_not_verify_error: 'ईमेल सत्यापित नहीं है',
    confirm: 'पुष्टि करें',
    timer_count: 'टाइमर गिनती',
    resend_verification_code: 'सत्यापन कोड पुनः भेजें',
    send_verification_code: 'सत्यापन कोड भेजें',
    input_field: '{{field}} दर्ज करें',
    code: 'कोड',
    successful_verify: 'सफलतापूर्वक सत्यापित',
    two_factor_authentication: 'दो-कारक प्रमाणीकरण',
    verification: 'सत्यापन',

    // KYC page
    verify: 'सत्यापित करें',
    security: 'सुरक्षा',

    kyc_status: {
      failed_verify_again: 'सत्यापन विफल, पुनः प्रयास करें',
      under_review: 'सत्यापन में',
      verify_now: 'अब सत्यापित करें',
    },

    complete_email_verification_to_unlock_some_function:
      'कुछ सुविधाओं को अनलॉक करने के लिए ईमेल सत्यापन पूरा करें',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'निकासी राशि को 100,000 USDT तक बढ़ाने के लिए पहचान सत्यापन पूरा करें',
    connect_wallet_to_spin: 'वॉलेट कनेक्ट करें',

    // enter code page
    link_email: 'ईमेल लिंक',
    unlink_email: 'ईमेल अनलिंक',
    expires_in: 'अवधि में <0>मिनट</0>.',
    resend_code: '<0>रिसेंड कोड</0>',
    enter_code: 'कोड दर्ज करें',
    unlink_email_confirm_msg: 'क्या आप वाकई ईमेल अनलिंक करना चाहते हैं?',
    link_success: 'ईमेल लिंक सफलतापूर्वक',
    unlink_success: 'ईमेल अनलिंक सफलतापूर्वक',
  },
  table_area: {
    pot: 'पॉट',
    waiting_for_other_players: 'अन्य खिलाड़ियों के आने का इंतजार कर रहे हैं...',
    waiting_for_game_start: 'खेल शुरू होने का इंतजार कर रहे हैं',
    sixty_sec: '60 सेकंड',
    please_select_emoji_target: 'कृपया खिलाड़ी चुनें',
  },
  best_combination: {
    hi_card: 'उच्च कार्ड ({{value}})',
    one_pair: 'एक जोड़ी ({{value}})',
    two_pairs: 'दो जोड़ी ({{firstPair}}, {{secondPair}})',
    set: 'तीन समान ({{value}})',
    straight: 'सीधी ({{fromValue}} से {{toValue}} तक)',
    flush: 'फ्लश ({{value}} उच्च कार्ड)',
    fullHouse: 'फुल हाउस ({{three_cards}} और {{two_cards}})',
    quad: 'चार समान ({{value}})',
    straight_flush: 'सीधी फ्लश ({{fromValue}} से {{toValue}} तक)',
    royal_flush: 'रॉयल फ्लश',
  },
  action_buttons: {
    place_bet: 'बेट लगाएं',
    all_in: 'ऑल-इन',
    bet: 'बेट',
    check: 'चेक',
    call: 'कॉल',
    raise: 'बढ़ाएं',
    fold: 'फोल्ड',
    pot: 'पॉट',
    confirm: 'पुष्टि करें',
    investment: 'निवेश',
    insurance: 'बीमा',
    choosing_cards: 'कार्ड चुनना',
    outs_number: 'आउट्स संख्या',
    insurance_winning_rate: 'विजय दर',
    odds: 'ऑड्स',
    premium: 'प्रीमियम',
    payout: 'इनाम',
    call_any: 'स्वचालित कॉल',
    wait_for_blinds: 'ब्लाइंड्स के बाद शामिल हों',
    join_directly: 'अगली बारी में शामिल हों',
    check_or_fold: 'चेक / फोल्ड',
    confirm_to_fold: 'क्या आप वाकई फोल्ड करना चाहते हैं?',
    max: 'अधिकतम',
    min: 'न्यूनतम',
    force_insurance: 'बाध्यकारी बीमा',
  },
  history_drawer: {
    title: 'कक्ष इतिहास',
    small_blind: 'स्मॉल ब्लाइंड (एंटे)',
    pre_flop: 'फ्लॉप से पहले',
    flop: 'फ्लॉप',
    turn: 'टर्न',
    river: 'रिवर',
    no_data: 'कोई कक्ष डेटा नहीं',
    hands: 'हाथ',
    winner: 'विजेता',
    buy_in: 'खरीद',
    pool: 'पॉट',
    win_player: 'विजयी खिलाड़ी',
    time: 'समय',
    main_pot: 'मुख्य पॉट',
    side_pot_one: 'साइड पॉट 1',
    side_pot_two: 'साइड पॉट 2',
    side_pot_three: 'साइड पॉट 3',
    win: 'जीत',
    loading: 'लोड हो रहा है',
    all_record_loaded: 'सभी कक्ष इतिहास लोड हो गए हैं',
    previous_page: 'पिछला पृष्ठ',
    close: 'बंद करें',
    detail: 'विवरण',
  },
  file_upload: {
    upload: 'अपलोड करें',
  },
  user_menu: {
    two_factor: 'दो-कारक प्रमाणीकरण',
    change_password: 'पासवर्ड बदलें',
    logout: 'लॉगआउट',
    hello_user: 'नमस्ते',
  },
  change_password_board: {
    change_password: 'पासवर्ड बदलें',
    old_password: 'पुराना पासवर्ड',
    new_password: 'नया पासवर्ड',
    confirm_password: 'पासवर्ड की पुष्टि करें',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: 'खोजें..',
    filter: 'फ़िल्टर',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: 'पढ़ें',
    write: 'लिखें',
    none: 'कोई नहीं',
    banned: 'प्रतिबंधित',
  },
  phone_input: {
    invalid_country_code: 'अमान्य देश कोड',
    invalid_phone: 'अमान्य फोन',
    phone_number: 'फोन नंबर',
    phone_code: 'कोड',
  },
  room_setting_drawer: {
    create_new_room: 'नया कमरा बनाएं',
    enter_room_code: 'कमरा कोड दर्ज करें',
    please_enter_a_valid_room_code: 'कृपया मान्य कोड दर्ज करें',
    please_input_room_code: 'कृपया कमरा कोड दर्ज करें',
    enter_room: 'कमरा दर्ज करें',
    room_setting: 'कमरा सेटिंग',
    small_blind: 'ब्लाइंड:',
    ante: 'एंटे:',
    buy_in: 'खरीद:',
    number_of_people: 'लोगों की संख्या:',
    action_time: 'क्रिया समय:',
    game_duration: 'खेल अवधि:',
    commission: 'कमीशन:',
    insurance: 'बीमा:',
    location_restriction: 'स्थान प्रतिबंध',
    diamond_needed: 'आवश्यक हीरे:',
    diamond_owned: 'मौजूदा हीरे:',
    redeem: 'हीरे खरीदें',
    open_room: 'कमरा खोलें',
    maximum: 'अधिकतम:',
    hours: '{{value}} घंटे',
    minute: '{{value}} मिनट',
    second: '{{value}} सेकंड',
    affect_diamond_needed: 'आवश्यक हीरे पर प्रभाव डालें',
    remaining_room_time: 'कमरा समाप्ति समय शेष है',
    diamond_require: 'आवश्यक हीरे:',
    time_increase: 'समय बढ़ाएं:',
    recharge: 'रीचार्ज',
    isAllIn: 'ऑल-इन',
    ipchecking: 'आईपी प्रतिबंध',
    diamond_not_enough: 'हीरे शेष अपर्याप्त',
  },
  gameRecharge: {
    sticker_title: 'स्टिकर',
    check_for_more: 'और देखने के लिए जांचें',
    diamond_title: 'हीरा',
    diamond_product_tag: '{{value}} हीरे',
    buy_diamond_confirm_msg: 'खरीद पुष्टि',
    buy_sticker_confirm_msg: 'क्या आप इस इमोजी स्टिकर को खरीदना चाहते हैं?',
    balance_not_enough_msg: 'आपका बैलेंस अपर्याप्त है',
    sticker_product_tag: '{{value}} हीरे की आवश्यकता है',
    confirm_to_buy_button: 'पुष्टि करें',
    confirm_title: 'खरीद पुष्टि',
    confirm_message:
      'क्या आप USD$ <0>{{usdAmount}}</0> में <1>{{diamondAmount}} हीरे</1> खरीदने की पुष्टि करते हैं?',
    redeem: 'रीचार्ज',
    confirm: 'पुष्टि करें',
    reminder: 'अनुस्मारक',
    not_enough_money: 'क्षमा करें, आपके पास हीरे खरीदने के लिए पर्याप्त बैलेंस नहीं है।',
    not_enough_diamond: 'आपके पास हीरे पर्याप्त नहीं हैं, कृपया पहले हीरे खरीदें।',
    quanity: 'मात्रा:',
    price: 'मूल्य:',
    diamond: 'हीरा',
    sticker: 'इमोजी स्टिकर',
    purchase_success: 'खरीद सफल',
    purchase: 'खरीदें',
    diamond_balance: 'हीरा बैलेंस',
    free_sticker: 'यह एक मुफ्त उत्पाद है',
    amount_required: 'मात्रा भरने की आवश्यकता है',
    valid_amount: 'कृपया मान्य मात्रा दर्ज करें',
    not_enough_diamond_balance: 'हीरा बैलेंस अपर्याप्त है',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'सभी',
      usd: 'USD',
      cash: 'नकद अनुभव कोड',
      diamond: 'हीरा',
    },
    transactionType: {
      createRoom: 'निजी कमरा खोलें',
      luckyDraw: 'लकी ड्रॉ खेलें',
      purchaseItem: 'इमोजी स्टिकर खरीदें',
      purchaseDiamond: '{{value}} हीरे खरीदें',
      joinGame: '{{value}} खेलों में भाग लें',
      winGame: '{{value}} खेलों में जीतें',
      loseGame: '{{value}} खेलों में हारें',
      winGameWithoutGameType: 'खेल जीतें',
      loseGameWithoutGameType: 'खेल हारें',
      joinGameWithoutGameType: 'खेल में भाग लें',
      deposit: 'रीचार्ज',
      redeemDemo: 'नकद कोड में बदलें',
      insurance: 'बीमा',
      gift: 'उपहार',
      firstLogin: 'पहली बार लॉगिन',
      privateRoomRebate: 'निजी कमरा रीबेट',
    },
    transactionRecord: 'लेनदेन विवरण',
    no_transaction_record: 'कोई लेनदेन रिकॉर्ड नहीं',
    currentMonth: 'इस माह',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: 'क्या आप इस इमोजी स्टिकर को खरीदना चाहते हैं?',
    sticker_product_tag: '{{value}} हीरे की आवश्यकता है',
    confirm_to_buy_button: 'खरीद की पुष्टि करें',
    emoji: 'इमोजी',
    free: 'मुफ्त',
    no_available_emoji: 'कोई उपलब्ध इमोजी स्टिकर नहीं',
  },
  playerInfo: {
    button: 'बैंकर',
    smallBlind: 'स्मॉल ब्लाइंड',
    bigBlind: 'बिग ब्लाइंड',
    cutOff: 'कटऑफ',
    underTheGun: 'अंडर द गन',
    bet: 'बेट',
    check: 'चेक',
    call: 'कॉल',
    raise: 'बढ़ाएं',
    fold: 'फोल्ड',
    cancelInsurance: 'बीमा रद्द करें',
    confirmInsurance: 'बीमा की पुष्टि करें',
    allIn: 'ऑल-इन',
    skip: 'छोड़ें',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: 'जमा करने की विधि',
    remark: 'टिप्पणी',
    ton_connect: 'TON कनेक्ट',
    manual_deposit: 'मैन्युअल जमा',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: 'जमा',
    withdraw: 'निकासी',
    withdrawal: 'निकासी',
    history: 'जमा/निकासी इतिहास',
    blockchain: 'ब्लॉकचेन',
    currency: 'मुद्रा',
    network: 'नेटवर्क',
    exchange_rate: 'विनिमय दर',
    deposit_address: 'जमा पता',
    deposit_process_message_1:
      'सिस्टम को धन प्राप्त होने पर तुरंत जमा प्रक्रिया शुरू हो जाएगी, प्रक्रिया में लगभग दो घंटे लगेंगे, कृपया धैर्य रखें।',
    back: 'वापस',
    address: 'पता',
    transaction_id: 'लेनदेन आईडी',
    amount: 'राशि',
    time: 'समय',
    coin_type: 'मुद्रा प्रकार',
    available_amount: 'उपलब्ध राशि',
    withdraw_amount: 'निकासी राशि',
    withdraw_cost: 'निकासी शुल्क',
    receiving_amount: 'प्राप्त होने वाली राशि',
    deposit_amount: 'जमा राशि',
    deposit_amount_placeholder: 'जमा राशि दर्ज करें',
    no_data: 'कोई डेटा नहीं',
    address_placeholder: 'पता दर्ज करें',
    amount_placeholder: 'राशि दर्ज करें',
    withdrawal_amount: 'निकासी राशि',
    withdrawal_fee: 'निकासी शुल्क',
    max: 'अधिकतम',
    available_cash_out_balance: 'उपलब्ध निकासी बैलेंस',
    cash_out_info:
      'पॉट में भाग लेने के बाद, आप केवल पोकर खेल में जीती गई USDT निकाल सकते हैं, या खेल टाई में निकाल सकते हैं।',
    wallet_balance: 'वॉलेट बैलेंस',
    deposit_pending_title: 'जमा लंबित',
    deposit_pending_description: 'आपका जमा वर्तमान में अनुमोदन के लिए लंबित है',
    deposit_success_title: 'जमा सफल',
    deposit_success_description: 'आपके खाते में फंड जमा कर दिया गया है',
    create_withdraw_success_title: 'निकासी अनुरोध सफल',
    create_withdraw_success_description: 'आपका निकासी अनुरोध संसाधित किया जा रहा है',
    withdrawal_success_title: 'निकासी सफल',
    withdrawal_success_description: 'आपका निकासी अनुरोध पूरा हो गया है',
    amount_required: 'राशि आवश्यक है',
    amount_exceeds_available: 'राशि उपलब्ध बैलेंस से अधिक है',
    amount_below_minimum: 'राशि न्यूनतम सीमा से कम है',
    amount_below_fee: 'राशि शुल्क से कम है',
    invalid_number: 'अमान्य संख्या',
    network_required: 'नेटवर्क चुनना आवश्यक है',
    address_required: 'पता भरना आवश्यक है',
    blockchain_required: 'ब्लॉकचेन चुनना आवश्यक है',
    email_required: 'ईमेल भरना आवश्यक है',
    valid_amount: 'कृपया मान्य राशि दर्ज करें',
    notice: 'सूचना',
    cancel: 'रद्द करें',
    cancel_transaction: 'आपने लेनदेन रद्द कर दिया है',

    from: 'से',
    receive_amount: 'प्राप्त राशि',

    // 2FA
    two_fa_required_msg: 'सुरक्षा के लिए, निकासी से पहले दो-कारक प्रमाणीकरण सेट करना अनिवार्य है।',
    setup_2fa: 'दो-कारक प्रमाणीकरण सेट करें',
    lost_my_2fa_access: 'दो-कारक प्रमाणीकरण खो गया',
    wallets_usdt_token: 'वॉलेट का USDT टोकन',
    memo_reminder_1:
      'कृपया सुनिश्चित करें कि आपने टिप्पणी अनुभाग में {{memo}} दर्ज किया है, अन्यथा हमारी प्रणाली आपके खाते में धनराशि जमा नहीं कर पाएगी।',
    memo_reminder_2:
      'यदि आप TonConnect का उपयोग कर रहे हैं, तो प्रणाली इसे स्वचालित रूप से भर देगी।',

    wait_for_next_lucky_draw:
      'कृपया अगली लकी ड्रॉ ईवेंट की प्रतीक्षा करें ताकि खेलने के लिए धन प्राप्त करने का अवसर मिल सके।',
  },
  history_status: {
    completed: 'पूरा हुआ',
    pending: 'प्रक्रियाधीन',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'सभी फ्लो',
      deposits: 'जमा',
      withdrawals: 'निकासी',
      bets: 'बेट्स',
      purchase: 'हीरे खरीदें',
      diamond: 'हीरा',
    },
    transaction_type: 'लेनदेन प्रकार',
    transaction_types: {
      deposits: 'जमा',
      withdrawals: 'निकासी',
      bets: 'बेट्स',
      purchase: 'हीरे खरीदें',
      diamond: 'हीरा',
      purchase_item: 'हीरे लेनदेन',
      referral_commission: 'रेफरल कमीशन',
      payout: 'इनाम',
      private_room: 'निजी कमरा खोलें',
      private_room_rebate: 'निजी कमरा रीबेट',
      reward: 'इनाम',
      lucky_draw: 'लकी ड्रॉ',
      tournament_prize: 'टूर्नामेंट पुरस्कार',
      tournament_ticket_fee: 'टूर्नामेंट टिकट शुल्क',
    },
    game_type: 'खेल प्रकार',
    type: 'प्रकार',
    bet: 'बेट',
    payout: 'इनाम',
    amount: 'राशि',
    quantity: 'मात्रा',
    balance: 'बैलेंस',
    diamond: 'हीरा',
    sticker: 'स्टिकर',
  },
  referral: {
    referral: 'रेफरल',
    invite_friends_description: 'मित्रों को Win4Poker में आमंत्रित करें, इनाम प्राप्त करें',
    whatsapp_referral_message:
      'क्या आप जीतने के लिए तैयार हैं? 🃏 आइए मेरे साथ Win4Poker में शानदार मुकाबलों का आनंद लें! यह मेरा आमंत्रण लिंक है: ',
    number_of_referrals: 'रेफरल संख्या',
    referral_rewards: 'रेफरल इनाम',
    my_commission: 'मेरा कमीशन',
    referral_code: 'रेफरल कोड',
    referral_link: 'रेफरल लिंक',
    enter_code: 'कोड दर्ज करें',
    terms_and_conditions: 'Win4Poker नियम और शर्तें',
    invite_friends: 'मित्रों को आमंत्रित करें',
    pop_up_title: 'सूचना',
    back_home: 'मुख्य पृष्ठ पर वापस जाएं',
    scan_qr_code: 'क्यूआर कोड स्कैन करें',
    code: 'कोड',
    copy_link: 'लिंक कॉपी करें',
    save_image: 'छवि सहेजें',
    whatsapp: 'व्हाट्सएप',
    telegram: 'टेलीग्राम',
    more: 'और',
    referral_history: 'रेफरल इतिहास',
    register_time: 'पंजीकरण समय',
    player: 'खिलाड़ी',
    reward_time: 'इनाम समय',
    reward_amount: 'इनाम राशि',
    referral_list: 'रेफरल सूची',
    enter: 'दर्ज करें',
    skip: 'छोड़ें',
    please_input_referral_code: 'कृपया रेफरल कोड दर्ज करें',
    enter_referral_code: 'रेफरल कोड दर्ज करें',
    enter_referral_code_success: 'रेफरल कोड सफलतापूर्वक दर्ज किया गया',
    cannot_use_own_referral_code: 'अपना स्वयं का रेफरल कोड उपयोग नहीं कर सकते',
    total: 'कुल',
    referral_code_invalid: 'रेफरल कोड अमान्य है',
    commission: 'कमीशन',
    reward_type: 'इनाम प्रकार',
    amount: 'राशि',
    commission_reward: 'कमीशन इनाम',
    commission_update_success: 'कमीशन सफलतापूर्वक अपडेट किया गया',
    commission_setting: 'कमीशन सेटिंग',
    save: 'सहेजें',

    // title
    promotion_1: 'रेफरल 1: जमा बोनस',
    promotion_2: 'रेफरल 2: रेफरल कोड इनाम',
    general_terms: 'सामान्य नियम और शर्तें',

    // sub-title
    eligibility: 'योग्यता',
    offer: 'ऑफ़र',
    conditions: 'शर्तें',
    program_duration: 'प्रोग्राम अवधि',
    account_verification: 'खाता सत्यापन',
    limitations: 'सीमाएँ',
    modification_of_terms: 'नियमों में संशोधन',
    compliance: 'अनुपालन',
    support: 'समर्थन',

    error_messages: {
      referral_code_invalid:
        'रेफरल कोड 4 से 8 वर्ण लंबा होना चाहिए, और इसमें केवल अल्फ़ान्यूमेरिक वर्ण हो सकते हैं, "I" और "O" को छोड़कर।',
      referral_code_required: 'रेफ़रल कोड आवश्यक है',
    },

    // points
    eligibility_1: 'उपयोगकर्ता को अपने Win4Poker खाते में 1 USDT से अधिक जमा करना होगा।',
    offer_1: 'योग्य उपयोगकर्ता को सीधे उनके खाते में 1 USDT का मुफ्त उपहार प्राप्त होगा।',
    conditions_1: 'यह ऑफ़र बिना सीमाओं के है।',
    conditions_2: 'जमा Win4Poker द्वारा निर्दिष्ट रेफरल अवधि के भीतर पूरा किया जाना चाहिए।',
    conditions_3: 'उपयोगकर्ता को पंजीकरण के लिए सत्यापित खाता होना चाहिए।',

    eligibility_2:
      'उपयोगकर्ता को अपने अद्वितीय रेफरल कोड का उपयोग करके मित्रों को रेफरल करना चाहिए।',
    offer_2:
      'जब रेफरल किए गए मित्र अपनी पहली गेम पूरा करते हैं, रेफरल करने वाले को इनाम के रूप में कुल पूल राशि का 3.5% प्राप्त होगा।',
    conditions_4: 'रेफरल किए गए मित्र को उपयोगकर्ता के कोड का उपयोग करके पंजीकरण करना होगा।',
    conditions_5:
      'इनाम रेफरल किए गए मित्र द्वारा गेम पूरा करने के 2 घंटे के भीतर वितरित किया जाएगा।',
    conditions_6:
      'उपयोगकर्ता अपने खाते के डैशबोर्ड के माध्यम से अपने रेफरल और इनाम को ट्रैक कर सकते हैं।',
    program_duration_1:
      'ये रेफरल कार्यक्रम हमारे वेबसाइट और आधिकारिक चैनलों पर संवाद किए गए निर्दिष्ट अवधि के दौरान आयोजित किए जाएंगे।',
    account_verification_1:
      'प्रतिभागियों को किसी भी इनाम योग्यता के लिए पूर्ण सत्यापित खाता होना चाहिए।',
    limitations_1:
      'रेफरल सिस्टम का दुरुपयोग करने वाले (जैसे खुद को रेफरल करना) उपयोगकर्ताओं के खाते निलंबित या प्रतिबंधित किए जा सकते हैं।',
    modification_of_terms_1:
      'Win4Poker इन रेफरल कार्यक्रमों में संशोधन या उन्हें किसी भी समय समाप्त करने का अधिकार रखता है, बिना पूर्व सूचना के।',
    compliance_1:
      'प्रतिभागियों को उनके न्याय क्षेत्र में लागू ऑनलाइन गेमिंग और रेफरल संबंधित कानूनों और नियमों का पालन करना चाहिए।',
    support_1:
      'रेफरल कार्यक्रम से संबंधित प्रश्नों या सहायता के लिए, कृपया हमारे ग्राहक समर्थन टीम से संपर्क करें।',

    // disclaimer
    disclaimer: 'अस्वीकरण',
    disclaimer_1:
      'सभी इनाम उपलब्धता पर निर्भर हैं, और खाता स्थिति और गतिविधि के आधार पर बदल सकते हैं।',
    disclaimer_2:
      'Win4Poker किसी भी तकनीकी समस्या के लिए जिम्मेदार नहीं है जो सफल रेफरल या इनाम को ट्रैक करने में बाधा डाल सकती है।',

    commission_calculation: {
      title: 'कमीशन गणना',
      first_layer: 'पहला स्तर %',
      second_layer: 'दूसरा स्तर %',
      third_layer: 'तीसरा स्तर %',
      refers: 'रेफर करता है',
      referrer: 'रेफरर',
      content:
        'विजेता की जीत का 5% कमीशन के रूप में काटा जाता है। गेटवे कमीशन का <0>अधिकतम</0> 30% प्राप्त करता है। गेटवे शेष 70% कमीशन को शीर्ष स्तर के रेफरर को वितरित करता है, जो कमीशन के 70% का Z% अगले स्तर के रेफरर को आवंटित कर सकता है। अगले स्तर का रेफरर Z% कमीशन का Y% नीचे के स्तर को आवंटित करने का निर्णय ले सकता है, और यह प्रक्रिया तब तक जारी रहती है जब तक कमीशन विजेता के रेफरर तक नहीं पहुंच जाता।',
      example: {
        title: 'उदाहरण:',
        winner_wins: 'विजेता की जीत: ${{value}}',
        total_commission: 'कुल कमीशन: ${{value}}',
        gateway_total_commission_max: 'गेटवे कुल कमीशन (अधिकतम): ${{value}}',
        referral_total_commission_min: 'रेफरल कुल कमीशन (न्यूनतम): ${{value}}',

        referral_commissions: 'रेफरल कमीशन (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: 'रेफरर 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: 'रेफरर 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: 'रेफरर 3: ${{totalCommission}} × X%',
      },
    },

    fixed_commission: 'स्थिर कमीशन',
    custom_commission: 'विशेष कमीशन',
    invalid_commission_percentage: 'अमान्य कमीशन प्रतिशत',
    commission_placeholder: 'कमीशन प्रतिशत दर्ज करें',
    my_share: 'मेरा हिस्सा',
  },
  ranking: {
    ranking: 'रैंकिंग',
    today: 'आज',
    this_week: 'इस सप्ताह',
    this_month: 'इस माह',
  },
  tournament: {
    you_have_won: 'आपने जीत लिया है',
    time_elapsed: 'समय बीत चुका है',
    prize_pool: 'पुरस्कार पूल',
    entries: 'प्रविष्टियां',
    of: 'का',
    congratulations: 'बधाई हो',
    thanks_for_your_joining: 'आपकी भागीदारी के लिए धन्यवाद',
    watch: 'देखें',
    see_result: 'परिणाम देखें',
    view_tournament: 'टूर्नामेंट देखें',
    deregister: 'पंजीकरण रद्द करें',
    start_in: '<0>countdown</0> में शुरू होगा',
    full: 'भरा हुआ',
    register_end_in: 'पंजीकरण <0>countdown</0> में समाप्त होगा',
    my_ranking: 'मेरी रैंकिंग',
    players: 'खिलाड़ी',
    register: 'पंजीकरण करें',
    pay_for_registration: 'पंजीकरण के लिए {{ticketFee}} का भुगतान करें',
    register_confirmation_message:
      'टूर्नामेंट के पंजीकरण के लिए, {{ticketFee}} टिकट शुल्क लगाया जाएगा, क्या आप {{tournamentName}} के लिए पंजीकरण करना चाहते हैं?',
    late_register: 'देर से पंजीकरण',
    level: 'स्तर',
    blinds: 'ब्लाइंड्स (SB/BB)',
    ante: 'एंटी',
    duration: 'अवधि',
    game_rule: 'खेल नियम',
    game_mode: 'खेल मोड',
    speed: 'गति',
    general_information: 'सामान्य जानकारी',
    ticket_fee: 'टिकट शुल्क',
    starting_stack: 'प्रारंभिक स्टैक',
    blinds_start: 'ब्लाइंड्स शुरू',
    ante_starts: 'एंटी शुरू',
    raised_every: 'हर इतने समय में बढ़ता है',
    minutes: 'मिनट',
    prize: 'पुरस्कार',
    structure: 'संरचना',
    gameModeTitle: {
      classic: 'क्लासिक',
      turbo: 'टर्बो',
      hyper: 'हाइपर',
    },
    gameModeDescription: {
      classic:
        'क्लासिक मल्टी-टेबल टूर्नामेंट जहां प्रतिभागी कुल पुरस्कार पूल का हिस्सा जीतने के लिए प्रतिस्पर्धा करते हैं।',
    },
    speedTitle: {
      regular: 'नियमित',
      turbo: 'टर्बो',
      hyper: 'हाइपर',
    },
    speedDescription: 'ब्लाइंड्स हर {{value}} मिनट में बढ़ते हैं',
    tournament: 'टूर्नामेंट',
    today: 'आज',
    yesterday: 'कल (बीता हुआ)',
    tomorrow: 'कल',
    upcoming: 'आगामी',
    results: 'परिणाम',
    on_going: 'जारी',
    title: 'टूर्नामेंट विवरण',
    tables: 'टेबल्स',
    minutes_short: 'मिनट',
    current_blinds: 'वर्तमान ब्लाइंड्स',
    next_blind_at: 'अगला ब्लाइंड कब',
    start_game_in: 'खेल शुरू होगा',
    no_tournaments_available: 'कोई टूर्नामेंट उपलब्ध नहीं है',
    you_have_not_participated_in_any_tournament_yet:
      'आपने अभी तक किसी भी टूर्नामेंट में भाग नहीं लिया है',
    tournament_started: 'टूर्नामेंट शुरू हो गया',
    tournament_ended_msg: 'टूर्नामेंट समाप्त हो गया',
    tournament_canceled_msg: 'टूर्नामेंट रद्द किया गया',
    view_table: 'टेबल देखें',
    view_player_table: 'खिलाड़ी टेबल देखें',
    table_rebalancing: 'टेबल रिबैलेंसिंग',
    upcoming: 'आगामी',
    in_progress: 'जारी',
    finished: 'समाप्त',
    waiting_enough_players_to_start: 'पर्याप्त खिलाड़ी शुरू होने के लिए इंतजार',
    cancelled: 'रद्द कर दिया',
    table_rebalancing: 'टेबल रीबैलेंसिंग',
    too_many_rooms_description:
      '{{tournamentName}} जल्द ही शुरू होगा, लेकिन आपने अधिकतम टेबल की संख्या तक पहुंच गए हैं, कृपया {{tournamentName}} में शामिल होने के लिए निम्नलिखित टेबलों में से कम से कम 1 को छोड़ें।',
    leave: 'छोड़ें',
    sit_in: '{{name}} में बैठें',
    ignore: 'अनदेखा करें',

    re_entry_modal: {
      title: 'टूर्नामेंट में फिर से प्रवेश करें?',
      description:
        '{{tournamentName}} अभी भी शामिल होने के लिए खुला है, क्या आप टूर्नामेंट में फिर से शामिल होने के लिए ${{ticketFee}} टिकट शुल्क खर्च करना चाहते हैं?',
      re_enter: 'फिर से प्रवेश करें',
      view_tournament: 'टूर्नामेंट देखें',
    },
    waiting_for_players: {
      title: 'खिलाड़ियों की प्रतीक्षा में',
      message: '{{count}} और खिलाड़ी के शामिल होने की प्रतीक्षा में',
      message_plural: '{{count}} और खिलाड़ियों के शामिल होने की प्रतीक्षा में',
    },
    thanks_for_joining: {
      title: 'शामिल होने के लिए धन्यवाद!',
      description: '{{tournamentName}} में शामिल होने के लिए धन्यवाद। टूर्नामेंट अभी भी चल रहा है, आप बाद में अपना परिणाम देख सकते हैं।',
      view_results: 'टूर्नामेंट परिणाम देखें',
    },
    cancel: {
      title: 'टूर्नामेंट रद्द किया गया',
      description: 'टूर्नामेंट "{{tournamentName}}" रद्द कर दिया गया है।',
      refund_message: 'आपकी प्रवेश शुल्क ${{amount}} वापस की जाएगी।',
      confirm: 'ठीक है',
    },
    waiting_timer: {
      title: 'खिलाड़ियों की प्रतीक्षा',
      cancel_in: 'रद्द होने में',
    },
    waiting_for_players_timer: 'खिलाड़ियों की प्रतीक्षा',
    cancel_in: 'रद्द होगा',
  },
  errorCodes: {
    default: {
      title: 'सिस्टम त्रुटि',
      message: 'कुछ गलत हो गया, कृपया बाद में फिर से प्रयास करें',
    },

    WS_0000: 'सिस्टम त्रुटि',
    WS_0001: 'चार से अधिक कमरों में प्रवेश नहीं किया जा सकता',
    WS_0002: 'सबसे अधिक दांव लगाने पर छोड़ना संभव नहीं है',
    WS_0003: 'सत्यापन त्रुटि, कृपया पृष्ठ को रिफ्रेश करके पुनः प्रयास करें',
    WS_0004:
      'कमरे में आस-पास के लोगों का पता चला है, इसलिए फिलहाल उस कमरे में प्रवेश नहीं किया जा सकता',
    WS_0005: 'सबसे अधिक दांव लगाने वाले खिलाड़ी को छोड़ नहीं सकते। कृपया पहले फोल्ड करें',
    WS_0006: 'खरीद त्रुटि',
    WS_0007: 'गेम रूम नहीं मिला',

    HP_0001: 'चार से अधिक कमरों में प्रवेश नहीं किया जा सकता',
    HP_0002: 'वर्तमान में सर्वर से कनेक्ट नहीं हो पा रहा है, कृपया बाद में पुनः प्रयास करें।',
    HP_0003: 'खरीद राशि अपर्याप्त',
    HP_0004: 'अमान्य सत्यापन कोड',
    INVALID_EMAIL_PASS_CODE: 'अमान्य सत्यापन कोड',
    INVALID_OTP: 'अमान्य सत्यापन कोड',
    INVALID_REFERRAL_CODE: 'अमान्य रेफरल कोड',
    REFERRAL_CODE_ALREADY_USED: 'रेफरल कोड पहले से उपयोग किया गया है',
    INSUFFICIENT_COINS: 'अपर्याप्त वॉलेट बैलेंस',
    JOIN_TOURNAMENT_ERROR: 'टूर्नामेंट में शामिल होने में त्रुटि',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: 'स्थान एक्सेस अस्वीकृत किया गया।',
      POSITION_UNAVAILABLE: 'स्थान जानकारी उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।',
      TIMEOUT: 'आपका स्थान प्राप्त करने का अनुरोध समय समाप्त हो गया। कृपया पुनः प्रयास करें।',
      UNKNOWN: 'आपके स्थान का अनुरोध करते समय एक अज्ञात त्रुटि हुई।',
    },
    TOURNAMENT_IS_FINISHED: 'टूर्नामेंट समाप्त हो गया है',
    GPS_RESTRICTION:
      'स्थान का पता नहीं लगाया जा सकता है या आपके पास के खिलाड़ी ने उसी कमरे में प्रवेश किया है, कृपया बाद में पुनः प्रयास करें',
  },
};
